import React from "react";

// "Powered by Medical Care Technologies Inc." badge rebuilt crisp (vector).
// Mirrors the purple/pink tech-head logo + wordmark seen in the mockups.
export default function MedicalCareBadge({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="medical-care-badge">
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="mc-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#c86bff" />
            <stop offset="55%" stopColor="#9a4cff" />
            <stop offset="100%" stopColor="#ff3bb7" />
          </linearGradient>
        </defs>
        <g stroke="url(#mc-g)" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
          {/* Head silhouette */}
          <path d="M14 30c0-10 8-18 18-18 6 0 11 3 14 7 3 4 4 9 4 14v5c0 4-1 6-4 8-3 2-5 5-5 9v3H22v-4c0-3-1-5-3-7-3-2-5-5-5-9v-8z" />
          {/* Circuit inside */}
          <path d="M22 32h6M22 26h4M22 38h5M34 22v6h6M34 30h5M34 36h7" />
          <circle cx="28" cy="32" r="1.6" fill="url(#mc-g)" />
          <circle cx="40" cy="28" r="1.6" fill="url(#mc-g)" />
          <circle cx="41" cy="36" r="1.6" fill="url(#mc-g)" />
          <circle cx="27" cy="26" r="1.2" fill="url(#mc-g)" />
          {/* Chip pins */}
          <path d="M10 22h4M10 30h4M10 38h4M50 22h4M50 30h4M50 38h4" />
        </g>
      </svg>
      <div className="leading-tight">
        <div
          className="font-display font-bold text-[10px] tracking-[0.32em]"
          style={{
            background: "linear-gradient(90deg,#c86bff,#ff3bb7)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          POWERED BY
        </div>
        <div
          className="font-display font-black text-base md:text-lg tracking-[0.14em]"
          style={{
            background: "linear-gradient(90deg,#ffffff, #e8e8e8)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          MEDICAL CARE<sup className="text-[8px] align-super">®</sup>
        </div>
        <div
          className="font-display font-bold text-[10px] tracking-[0.4em]"
          style={{
            background: "linear-gradient(90deg,#c86bff,#ff3bb7)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          TECHNOLOGIES INC.
        </div>
      </div>
    </div>
  );
}
